import React, { Component } from 'react';
import styled from 'styled-components';

class Footer extends Component {
  render() {
    return (
      <div className={this.props.className}><span>Piske&Usagi. by Kanahei</span></div>
    );
  }
}

export default styled(Footer)`
  position: relative;
  width: 100%;
  display:flex;
  justify-content: flex-end;
  @media (max-width:767px) {
    font-size: .8em;
    padding: 0px 0px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Footer/index.js